import React from 'react';
import PropTypes from 'prop-types';
import { ConditionsShape } from 'next/entities/rules';
import {
  H3,
  HorizontalScroll,
  Radio,
  RadioGroup,
  RadioLabel,
  RadioControl,
} from 'next/components/ui';
import Conditions from 'next/components/Conditions';

import {
  Section,
  Targeting,
  HelpText,
  HelpTextEmphasis,
  SectionTitle,
} from './styled';

export const PERMISSIVE_CONDITION = { url: { operator: 'regex', value: '.*' } };
export const DEFAULT_CONDITION = { url: { operator: '*', value: '/' } };

const Path = ({ conditions = { and: [PERMISSIVE_CONDITION] }, onChange }) => {
  const { and, or } = conditions;
  const subConditions = and || or;
  const [
    {
      url: { operator, value },
    },
  ] = subConditions;

  const currentMode =
    subConditions.length === 1 && operator === 'regex' && value === '.*'
      ? 'any'
      : 'path';

  const handleModeChange = mode => {
    onChange({
      and: [mode === 'any' ? PERMISSIVE_CONDITION : DEFAULT_CONDITION],
    });
  };

  return (
    <Section>
      <H3>Page targeting</H3>
      <SectionTitle>
        What page should this Pin Experience appear on?
      </SectionTitle>
      <RadioGroup
        name="mode"
        value={currentMode}
        onValueChange={handleModeChange}
      >
        <RadioControl>
          <Radio id="any" value="any" />
          <RadioLabel htmlFor="any">Any page</RadioLabel>
        </RadioControl>
        <RadioControl>
          <Radio id="path" value="path" />
          <RadioLabel htmlFor="path">At a specific path</RadioLabel>
        </RadioControl>
        {currentMode === 'path' && (
          <Targeting>
            <HorizontalScroll>
              <Conditions
                validClauseTypes={['url']}
                conditions={conditions}
                onChange={onChange}
              />
            </HorizontalScroll>
            <HelpText>
              Matches the path after the domain, e.g. http://www.example.com/
              <HelpTextEmphasis>[path]</HelpTextEmphasis>
            </HelpText>
          </Targeting>
        )}
      </RadioGroup>
    </Section>
  );
};

Path.propTypes = {
  conditions: ConditionsShape,
  onChange: PropTypes.func,
};

export default Path;
